var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "10px",
    viewBox: "0 0 21 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B6977CA1-F476-4AC3-BC94-FE2476ACE926") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Management---PLP",
    transform: "translate(-296.000000, -143.000000)",
    fill: "#F88801"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.838726,147.193548 L298.759774,147.193548 L301.588968,144.378065 C301.904653,144.063871 301.905863,143.553266 301.591669,143.237581 C301.277476,142.921855 300.766831,142.920685 300.451145,143.234839 L296.237274,147.428387 C296.236992,147.428629 296.23679,147.428911 296.236548,147.429153 C295.921669,147.743347 295.920661,148.255605 296.236468,148.570847 C296.23675,148.571089 296.236952,148.571371 296.237194,148.571613 L300.451065,152.765161 C300.76671,153.079274 301.277355,153.078185 301.591589,152.762419 C301.905782,152.446734 301.904573,151.936129 301.588887,151.621935 L298.759774,148.806452 L315.838726,148.806452 C316.284129,148.806452 316.645177,148.445403 316.645177,148.000003 C316.645177,147.554597 316.284129,147.193548 315.838726,147.193548",
    id: "back"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.27a12850.svg";
export { ForwardRef as ReactComponent };